module.exports = __webpack_public_path__ + "static/media/gThompson.f045b87a.jpeg";